
import React from 'react';
import { FIRST_NAME, LAST_NAME, EMAIL, ACCOUNT_NUMBER, ENVELOPE_ID, ELECTRONIC_SIGNING_TYPE } from "./prm";
import {TextLoading} from "../../funcs/utils";
import {Modal2} from "../modal";
import {adminCreateUser} from "./actions";
import { poll_tda_item } from "./tda_utils";
import {sprintf} from "sprintf-js";
import {AccountState} from "../../../lib/constants";
import {onboarding_start_segment} from "../../../lib/onboarding-utils";

const remove_blanks = str => {
  const re = /^\s*(\S+)\s*$/;
  const match = str.match(re);
  if (!match) {
    return str;
  }
  return match[1];
}

const add_user = (component, wlf) => () => {

  const token = component.props.token;
  const segment = onboarding_start_segment(wlf);
  let tda_item;

  component.setState({
    dialog_exec: true,
  });
  adminCreateUser(
    token,
    remove_blanks(FIRST_NAME.getValue(component.state)),
    remove_blanks(LAST_NAME.getValue(component.state)),
    wlf.id,
    remove_blanks(EMAIL.getValue(component.state)),
    remove_blanks(ACCOUNT_NUMBER.getValue(component.state)),
    ELECTRONIC_SIGNING_TYPE.getValue(component.state).id,
    {
      envelope_id: remove_blanks(ENVELOPE_ID.getValue(component.state)),
    })
    .then(result => {
      if (!result.success) {
        component.setState({
          add_user_error: result.message,
          dialog_exec: false,
        })
        return;
      }
      // Success
      const { username, identity_id, name } = result;
      poll_tda_item(
        token, {}, username, identity_id, 0, wlf.id, true)
        .then(onboarding_items => {
          tda_item = onboarding_items.tda;

          component.setState({
            show_add_user_dialog: null,
            dialog_exec: false,
          });
          return component.maybeLoad(true);
        })
        .then(() => {
          return component.load_user_items(username);
        })
        .then(() => {
          const url = sprintf("/super-admin/onboarding_%04d/%s", 0, segment);
          const args = {
            username,
            acct_index: 0,
            identity_id,
            account_state: AccountState.ONBOARDING_PROXY,
            tda_account_number: tda_item.tda_account_number,
            name,
          }
          component.props.navigatePath(url, args);
        })

    });

}

const AddUserModal = props => {

  const { component, wlf } = props;

  if (!component.state.show_add_user_dialog) {
    return null;
  }
  if (component.state.show_add_user_dialog.wlf_id !== wlf.id) {
    return null;
  }

  const container_style = {
    width: "30rem",
  }
  const on_close = () => {
    component.setState({
      show_add_user_dialog: null,
    })
  }
  const loading = component.state.dialog_exec;
  const button_list = [
    {
      label: "Cancel",
      cb: on_close,
    },
    {
      label: (
        <TextLoading
          loading={loading}
          label={"Add User"}/>
      ),
      cb: add_user(component, wlf),
    }
  ];

  const header_style = {
    padding: "0.5rem",
  }
  const header = "Add User";
  const div_style = {
    marginBottom: "1rem",
  }

  const dump_label_text = (prm, label) => {
    return (<div>
      <div>{label}</div>
      <div style={div_style}>{ prm.renderInput(component)}</div>
    </div>)
  }
  return (
    <Modal2
      container_style={container_style}
      header_style={header_style}
      header={header}
      buttonList={button_list}>
      <div>
        { dump_label_text(FIRST_NAME, "First Name") }
        { dump_label_text(LAST_NAME, "Last Name") }
        { dump_label_text(EMAIL, "Email") }
        { dump_label_text(ACCOUNT_NUMBER, "Account Number") }
        <div>Envelope Type</div>
        <div style={div_style}>{ ELECTRONIC_SIGNING_TYPE.renderMenu(component)}</div>
        { dump_label_text(ENVELOPE_ID, "Docusign Envelope Id:")}
      </div>
    </Modal2>
  );
};

const AddUserErrorModal = props => {
  const component = props.component;
  const error = component.state.add_user_error;
  if (!error) {
    return null;
  }
  const on_close = () => {
    component.setState({
      add_user_error: null,
    })
  }
  const button_list = [
    {
      label: "Ok",
      cb: on_close,
    }
  ]

  return (
    <Modal2
      buttonList={button_list}>
      <div>
        Error: {error}
      </div>
    </Modal2>
  )

}

export { AddUserModal, AddUserErrorModal };
